import { useState } from 'react';
import { ChevronDown } from '../components/icons';
import { FAQ_GROUPS } from '../content/faq';

export function FaqPage() {
  const [open, setOpen] = useState<string | null>(FAQ_GROUPS[0]?.items[0]?.q ?? null);

  return (
    <>
      <section className="px-6 pt-28 pb-12 lg:px-10 lg:pt-36">
        <div className="mx-auto max-w-[760px]">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
            FAQ
          </div>
          <h1 className="font-display mb-4 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.375rem]">
            Questions we hear before signup.
          </h1>
          <p className="text-[1.0625rem] leading-[1.7] text-ink-2">
            Plans, POS, tax, and what cevop is not. Deeper walkthroughs live in Help.
          </p>
        </div>
      </section>

      <section className="px-6 pb-20 lg:px-10">
        <div className="mx-auto max-w-[760px] space-y-10">
          {FAQ_GROUPS.map((group) => (
            <div key={group.id}>
              <h2 className="font-display mb-3 text-[1.15rem] font-bold text-ink">{group.title}</h2>
              <div className="space-y-2">
                {group.items.map((item) => {
                  const isOpen = open === item.q;
                  return (
                    <div key={item.q} className="overflow-hidden rounded-xl border border-line bg-panel shadow-sm">
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                        onClick={() => setOpen(isOpen ? null : item.q)}
                      >
                        <span className="text-[0.875rem] font-semibold text-ink">{item.q}</span>
                        <ChevronDown className={`shrink-0 text-ink-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
                      </button>
                      {isOpen && (
                        <div className="mk-faq-in border-t border-surface-2 px-5 pb-4 text-[0.85rem] leading-[1.7] text-ink-3">
                          {item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
